<template>
  <div>
    <monitoring-disclaimer class="q-my-md" />

    <posts-toolbar v-model:filters="filters" />
    <posts-view-options
      v-model:filters="filters"
      v-model:pagination-mode="paginationMode"
    />

    <posts
      v-if="filters.socialSiteIds.length"
      :filters="filters"
      :persist="paginationMode === 'scroll'"
      :infinite-scroll="paginationMode === 'scroll'"
      :new-page-top="paginationMode === 'manual'"
      @total="$emit('total', $event)"
    >
      <template v-slot="{ visiblePosts }">
        <posts-grid :posts="visiblePosts">
          <template v-slot="post">
            <post
              :post="post"
              :highlight="getHighlightRules(post)"
              show-client
              notes
              trash
              actions
              scrollable
            />
          </template>
        </posts-grid>
      </template>
    </posts>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post as PostType, PostFilters } from '@/type';
import { status } from '@/social/post/post';
import MonitoringDisclaimer from '@/social/post/flagging/MonitoringDisclaimer.vue';
import PostsGrid from '@/social/post/list/PostsGrid.vue';
import Post from '@/social/post/card/Post.vue';
import { StringMatchRule } from '@/util/string';
import Posts from '../Posts.vue';
import PostsToolbar from '../ResponsivePostsToolbar.vue';
import PostsViewOptions from '../PostsViewOptions.vue';

interface Data {
  filters: PostFilters,
  paginationMode: string,
}

export default defineComponent({
  emits: ['total'],
  components: {
    PostsViewOptions,
    PostsGrid,
    Post,
    MonitoringDisclaimer,
    PostsToolbar,
    Posts,
  },
  data(): Data {
    return {
      filters: {
        statuses: [status.UNREVIEWED, status.SAVED, status.ESCALATED, status.RESOLVED],
        socialSiteIds: [],
        isTrashed: false,
        isFlagged: true,
        since: undefined,
        until: undefined,
        mediaTypes: [],
        order: 'desc',
      },
      paginationMode: 'scroll',
    };
  },
  methods: {
    getHighlightRules(post: PostType): StringMatchRule[] {
      if (!post.flaggedWords) return [];
      return post.flaggedWords.map(word => ({
        operation: 'contains',
        needle: word,
      }));
    },
  },
});
</script>
